module.exports = __webpack_public_path__ + "img/zhxy.0c3fda26.png";